var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.055 7.356l3.813 3.824c.39.392 1.031.386 1.422-.006.39-.39.395-1.027.006-1.418L8.763 5.21a1 1 0 00-1.417 0L2.704 9.866c-.39.39-.383 1.028.006 1.418.39.392 1.031.398 1.422.006l3.923-3.934z",
    fill: "#000"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04LjA1NSA3LjM1NmwzLjgxMyAzLjgyNGMuMzkuMzkyIDEuMDMxLjM4NiAxLjQyMi0uMDA2LjM5LS4zOS4zOTUtMS4wMjcuMDA2LTEuNDE4TDguNzYzIDUuMjFhMSAxIDAgMDAtMS40MTcgMEwyLjcwNCA5Ljg2NmMtLjM5LjM5LS4zODMgMS4wMjguMDA2IDEuNDE4LjM5LjM5MiAxLjAzMS4zOTggMS40MjIuMDA2bDMuOTIzLTMuOTM0eiIgZmlsbD0iIzAwMCIvPgo8L3N2Zz4K";
export { SvgDropArrow as ReactComponent };